import styled from "styled-components";

export type StyledSVGProps = {
  icon: any;
  fill?: string;
  alt?: string;
  className?: string;
};

const StyledSVGContainer = styled.span<StyledSVGProps>`
  svg {
    fill: ${(props) => props.fill};
    path {
      fill: ${(props) => props.fill} !important;
    }
  }
`;

export default function StyledSVG(props: StyledSVGProps) {
  return (
    <StyledSVGContainer {...props}>
      <props.icon className={props.className} alt={props.alt} />
    </StyledSVGContainer>
  );
}
